module.exports = __webpack_public_path__ + "images/pno_small408464895610fe856f72da0561d0c6b3.png";